const TableUtils = {
  deleteColumnByProp(columns, value) {
    try {
      let idIndex = columns.findIndex(item => {
        return item.props.prop === value
      })
      if (idIndex > 0) {
        columns.splice(idIndex, 1)
      }
    } catch (e) {
      console.error(e)
    }
  },
  deleteColumnByDataType(columns, value) {
    try {
      let idIndex = columns.findIndex(item => {
        return item.dataType === value
      })
      if (idIndex > 0) {
        columns.splice(idIndex, 1)
      }
    } catch (e) {
      console.error(e)
    }
  },
  setColumnByProp(columns, pos, prop, value) {
    try {
      for (let idx = columns.length - 1; idx >= 0; idx--) {
        let column = columns[idx]
        if (column?.props?.prop === pos) {
          column.props[prop] = value
          break
        }
      }
    } catch (e) {
      console.error(e)
    }
  }
}
export default TableUtils
